import {Fragment, memo, useCallback} from 'react';
import {translate} from '../../utils';
import {useAddGuestsStatic} from './AddGuestsContext';
import {AddGuestsTableRowWithGuest} from './AddGuestsTableRowWithGuest';

export const AddGuestsTableRoomRows = memo(function AddGuestsTableRoomRows({
    room,
    roomIndex,
    isLastRoom,
    errors,
    setErrors,
    regionMaps,
    onRegionMapsUpdate,
    setFieldValue,
    onAddGuest,
    onRemoveGuest,
    onSelectClientSuggestion,
}) {
    const {guestColumnKeys, maxGuestsPerRoom} = useAddGuestsStatic();
    const handleAddGuest = useCallback(() => onAddGuest(roomIndex), [onAddGuest, roomIndex]);

    return (
        <Fragment>
            {room.guests.map((guest, guestIndex) => (
                <AddGuestsTableRowWithGuest
                    key={`${roomIndex}-${guestIndex}`}
                    roomMaxOccupancy={room.maxOccupancy}
                    roomName={room.roomName}
                    roomCategoryName={room.categoryName}
                    guestsCountInRoom={room.guests.length}
                    roomIndex={roomIndex}
                    guest={guest}
                    guestIndex={guestIndex}
                    errors={errors}
                    setErrors={setErrors}
                    regionMaps={regionMaps}
                    onRegionMapsUpdate={onRegionMapsUpdate}
                    setFieldValue={setFieldValue}
                    onAddGuest={handleAddGuest}
                    onRemoveGuest={onRemoveGuest}
                    onSelectClientSuggestion={onSelectClientSuggestion}
                />
            ))}

            {room.guests.length === 1 && (
                <tr key={`${roomIndex}-add-guest-row`}>
                    <td className="text-right" data-column-key="addGuest">
                        <button
                            type="button"
                            className="btn btn-default btn-sm"
                            title={translate('frontend', 'ADD_GUESTS_ADD_GUEST')}
                            disabled={room.guests.length === maxGuestsPerRoom}
                            onClick={handleAddGuest}
                        >
                            <i className="fa fa-user-plus" />
                        </button>
                    </td>

                    <td colSpan={guestColumnKeys.length} />

                    <td data-column-key="guestActions"></td>
                </tr>
            )}

            {!isLastRoom && (
                <tr
                    key={`${roomIndex}-rooms-divider`}
                    className="add-guests__rooms-divider"
                >
                    <td data-column-key="roomKeyAndCategory"><div></div></td>
                    <td colSpan={guestColumnKeys.length}><div></div></td>
                    <td data-column-key="guestActions"><div></div></td>
                </tr>
            )}
        </Fragment>
    );
});
